import React from 'react';
import { useSelector } from 'react-redux';

import MapTool2D from './For2D';
import MapTool3D from './For3D';

const MapTool = () => {
  const isShowMap3d = useSelector((state) => state.map3d.isShow);

  return (
    <>
      {!isShowMap3d && <MapTool2D />}
      {isShowMap3d && <MapTool3D />}
    </>
  );
};

export default MapTool;
